<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/licensecheckzbperson/${activeName}/${pageIndex}`">
                        <i class="el-icon-arrow-left" style="cursor: pointer;"></i>
                        牌照审核
                    </router-link>/ 总部业务员牌照详情
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">车主及业务员信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item1">
                    <li>车主:{{seelicenseApplylist.ownerName}}</li>
                    <li>手机号:{{seelicenseApplylist.ownerCellphoneNumber}}</li>
                    <li>办理业务员:{{seelicenseApplylist.applicantName}}</li>
                </ul>
                <ul class="seelicense-item1">
                    <li>地区:{{seelicenseApplylist.provinceName}}{{seelicenseApplylist.cityName}}</li>
                    <li>身份证号:{{seelicenseApplylist.ownerIdentityCards}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.ownerIdentityCardsPhoto">
                    <li>身份证照片:</li>
                    <li v-for="item in seelicenseApplylist.ownerIdentityCardsPhoto">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
            </div>

            <p class="purchasesee-title" style="border-left: none;"></p>

            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>设备编号:{{seelicenseApplylist.equipmentCode}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>环保编码：{{seelicenseApplylist.environmentalProtectionNumber}}</li>
                    <li>排放登记: {{seelicenseApplylist.emissionRegistration}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>发动机功率：{{seelicenseApplylist.enginePower}}</li>
                    <li>机械品牌: {{seelicenseApplylist.machineryBrand}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>机械颜色：{{seelicenseApplylist.machineryColor}}</li>
                    <li>机械类型: {{seelicenseApplylist.machineryType}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>生产国别：{{seelicenseApplylist.productionCountry}}</li>
                    <li>整机架号: {{seelicenseApplylist.frameNo}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>燃油类型：{{seelicenseApplylist.fuelType}}</li>
                    <li>发动机号: {{seelicenseApplylist.engineNumber}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>整机质量：{{seelicenseApplylist.overallQuality}}</li>
                    <li>出厂日期: {{seelicenseApplylist.productionDateStr}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>核载质量：{{seelicenseApplylist.nuclearInformation}}</li>
                    <li>生产厂家：{{seelicenseApplylist.factory}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.mechanicalPictures">
                    <li>机械图片:</li>
                    <li v-for="item in seelicenseApplylist.mechanicalPictures">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
            </div>
            <p class="purchasesee-title">邮寄地址</p>
            <div class="purchasesee-padding">
                <p class="seelicense-item5">收货人姓名: {{seelicenseApplylist.shippingName}}</p>
                <p class="seelicense-item5">收货人手机号: {{seelicenseApplylist.shippingCellphoneNumber}}</p>
                <p class="seelicense-item5">收货地址: {{seelicenseApplylist.shippingAddress}}</p>
            </div>
            <p class="purchasesee-title">易车信息</p>
            <div class="purchasesee-padding">
                <ul
                    class="seelicense-item4"
                    v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                >
                    <li
                        v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                    >车主变更</li>
                    <li
                        v-if="seelicenseApplylist.receiverName"
                    >接收人:{{seelicenseApplylist.receiverName}}</li>
                    <li
                        v-if="seelicenseApplylist.receiverCellphoneNumber"
                    >接收人电话: {{seelicenseApplylist.receiverCellphoneNumber}}</li>
                    <li
                        v-if="seelicenseApplylist.receiverIdentityCards"
                    >接收人证件号: {{seelicenseApplylist.receiverIdentityCards}}</li>
                </ul>
                <p class="seelicense-item2" v-else>无</p>
            </div>
        </div>

        <p style="margin-top: 20px;">
            <el-button type="primary" @click="passseeApply()">通过</el-button>
            <el-button type="primary" @click="fallbackapplyfirst('fallbackform')">退回</el-button>
        </p>

        <el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
            <el-form ref="fallbackform" :model="fallbackform">
                <el-form-item label prop="auditReason">
                    <el-input
                        type="textarea"
                        v-model="fallbackform.auditReason"
                        placeholder="请输入回退原因"
                        class="resizeNone"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savefallbackfirst()">确 定</el-button>
                <el-button @click="fallbackVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
	getLicenseApplyExamine,
	examineLicenseApply,
	examineLicenseApply1,
	getMechanicsTransactionApplyExamine,
	examineMechanicsTransactionApply1,
	examineMechanicsTransactionApply,
} from '@/api/index';
export default {
	
    name: 'seelicensecheckxcxfirst',
    data() {
        return {
			licenseApplyId:'',
			seelicenseApplylist:{},//查看
			fallbackVisible:false,
			fallbackform:{
				auditReason:''
			},
			licenseArrId:[],
			activeName:'',
			pageIndex:'',
        };
    },
    created() {
			this.activeName = this.$route.params.activeName
			this.pageIndex = this.$route.params.pageIndex
			
			this.licenseApplyId = this.$route.params.licenseApplyId;
			this.licenseArrId.push(this.$route.params.licenseApplyId);
		// 查看
			
			if(this.activeName=='second' || this.activeName=='third') {
				getMechanicsTransactionApplyExamine({
					"mechanicsTransactionApplyId": this.licenseApplyId
				}).then(res => {
					this.seelicenseApplylist = res.data;
				});
			}else {
				getLicenseApplyExamine({
					"licenseApplyId": this.licenseApplyId
				}).then(res => {
					console.log(res.data)
					this.seelicenseApplylist = res.data;
					if(res.data.ownerIdentityCardsPhoto){
						this.seelicenseApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(',');
					}
					if(res.data.mechanicalPictures){
						this.seelicenseApplylist.mechanicalPictures = res.data.mechanicalPictures.split(',');
					}
				});
			}
    },
    methods: {
	// 通过
	  passseeApply(){
			let reqFun = ''
			let reqObj = {
				isPass: 1,
			}
			let licenseApplyIdsArr = [this.licenseApplyId]
			
			if(this.activeName=='first') { //牌照审核
				reqFun = examineLicenseApply
				reqObj.licenseApplyIds= licenseApplyIdsArr
			}else if(this.activeName=='second') { //车辆变更审核
				reqFun = examineMechanicsTransactionApply1
				reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
			}else if(this.activeName=='third') { //车主变更审核
				reqFun = examineMechanicsTransactionApply
				reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
			}else if(this.activeName=='fourth') { //机械牌照修改审核
				reqFun = examineLicenseApply
				reqObj.licenseApplyIds= licenseApplyIdsArr
			}
			
			this.$confirm('确定要通过吗？', '提示', {
					type: 'warning'
			}).then(() => {
					reqFun(reqObj).then(res => {
						if(res.code == 0){
							// 获取数据成功后的其他操作
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.$router.push(`/licensecheckzbperson/${this.activeName}/${this.pageIndex}`);
					listTaskRemindNum({}).then(ress => {
							 this.$store.state.totalNum =  ress.data.totalNum;
					});
						}else {
							this.$message({
								message: res.message,
								type: 'error'
							});
						}
						
					});
				
			}).catch(() => {});
	  },
	  // 退回弹框
	  fallbackapplyfirst(formName){
	  	this.fallbackVisible = true;
	  	//重置表单数据
	  	this.$nextTick(()=>{
	  	  this.$refs.[formName].resetFields();
	  	})
	  },
	  
	  //退回弹框确定按钮
	  savefallbackfirst(){
			let reqFun = ''
			let reqObj = {
				auditReason: this.fallbackform.auditReason,
				isPass: 2,
			}
			let licenseApplyIdsArr = [this.licenseApplyId]
			
			if(this.activeName=='first') { //牌照审核
				reqFun = examineLicenseApply
				reqObj.licenseApplyIds= licenseApplyIdsArr
			}else if(this.activeName=='second') { //车辆变更审核
				reqFun = examineMechanicsTransactionApply1
				reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
			}else if(this.activeName=='third') { //车主变更审核
				reqFun = examineMechanicsTransactionApply
				reqObj.mechanicsTransactionApplyIds = licenseApplyIdsArr
			}else if(this.activeName=='fourth') { //机械牌照修改审核
				reqFun = examineLicenseApply
				reqObj.licenseApplyIds= licenseApplyIdsArr
			}
	  	this.$confirm('确定要退回吗？', '提示', {
	  	    type: 'warning'
	  	}).then(() => {
					reqFun(reqObj).then(res => {
						if(res.code == 0){
							// 获取数据成功后的其他操作
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.fallbackVisible = false;
							// this.$router.push('/licensecheckfzorgan');
							this.$router.push(`/licensecheckzbperson/${this.activeName}/${this.pageIndex}`);
						listTaskRemindNum({}).then(ress => {
								 this.$store.state.totalNum =  ress.data.totalNum;
						});
						}else {
							this.$message({
								message: res.message,
								type: 'error'
							});
						}
					});
	  	}).catch(() => {});
	  },
    }
};
</script>

<style scoped>
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 20px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-itemphoto {
    display: flex;
    display: -webkit-flex;
    list-style: none;
    padding-left: 35px;
    color: #666;
}
.seelicense-itemphoto li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-itemphoto li:first-child {
    width: 100px;
}
.seelicense-itemphoto li img {
    width: 100%;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}
.seelicense-item5 {
    padding-left: 35px;
    height: 32px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #666;
}

.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
